import { ApproverSettings } from 'types'

export const GLOBAL_APPROVERS = ['UMU21GS7Q']
export const DIGITAL_APPROVERS = [
  'U06LJAMPWJ1', // Thomas Ziolkowski
  'U01FK2W9YNS', // Ryan Dixon
]
export const CREATIVE_APPROVERS = [
  'UPH8S2B9B', // Philip Sanford
  'U03RWJJ4LRJ', // Brooke Santana
  'U01HSHDCFHU', // Anna Sella
]
export const WEBSITE_APPROVERS = [
  'UPH8S2B9B', // Philip Sanford
]
export const SEO_LAUNCHPAD_APPROVERS = [
  'U01FK2W9YNS', // Ryan Dixon
  'U015KLM51B6', // Patric Cavanaugh
]
export const MSA_HOUSING_APPROVERS = []
// 'U015KLM51B6', // Patric Cavanaugh
// 'UHKAA49CJ', // Justin Widmayer
// 'U062JDP8R5X', // Colin Cavanaugh
export const INITIAL_STATE = {
  creative: [...GLOBAL_APPROVERS, ...CREATIVE_APPROVERS],
  msa: [...GLOBAL_APPROVERS, ...DIGITAL_APPROVERS],
  seo: [...GLOBAL_APPROVERS, ...SEO_LAUNCHPAD_APPROVERS],
  website: [...GLOBAL_APPROVERS, ...WEBSITE_APPROVERS],
  housing: [...GLOBAL_APPROVERS],
}
/**
 * Which approver list a product's category belongs to.
 *
 * The catalog renamed its categories (`Website` became `Web Development`,
 * `Digital` split into `Paid Media` and `Social Media`, and `UX/Design` was
 * added) while this only knew the old names, so every website product fell
 * through to the MSA list. Website-only CSAs were going to the MSA approver
 * and never to Website or Creative (found 1 October 2026). Old names are kept
 * because products already on deals still carry them.
 */
export const categoryToKey = (category: string): keyof ApproverSettings => {
  switch (category) {
    case 'Creative':
      return 'creative'
    case 'Website':
    case 'Web Development':
    case 'UX/Design':
      return 'website'
    case 'SEO':
    case 'LaunchPad':
      return 'seo'
    default:
      // Digital, Paid Media, Social Media, Email Marketing, Analytics, Loop,
      // Integration, and anything uncategorised.
      return 'msa'
  }
}

/**
 * Approver ids for a contract request: the deal type picks the rule, the
 * products' categories pick the lists.
 *
 * A CSA always includes the Creative list, whatever its products. A
 * website-only CSA used to reach no one on the creative side, and the business
 * owner set on 1 October 2026 that every CSA goes past Creative.
 */
export const approverIdsForDeal = (
  dealType: string,
  categories: string[],
  globalApprovers: Partial<ApproverSettings>,
): string[] => {
  const listFor = (key: keyof ApproverSettings): string[] => globalApprovers[key] ?? []
  switch (dealType) {
    case 'CSA':
    case 'RCSA':
      return Array.from(new Set([...listFor('creative'), ...categories.flatMap(c => listFor(categoryToKey(c)))]))
    case 'MSA':
    case 'RMSA':
      return Array.from(new Set(categories.flatMap(c => listFor(categoryToKey(c)))))
    case 'MSA - Housing':
    case 'RMSA - Housing':
    case 'IO':
      return categories.length > 0 ? [...listFor('housing')] : []
    default:
      return []
  }
}
